import { render, staticRenderFns } from "./FGTSConsultRedesign.vue?vue&type=template&id=38c95625&scoped=true"
import script from "./FGTSConsultRedesign.vue?vue&type=script&lang=js"
export * from "./FGTSConsultRedesign.vue?vue&type=script&lang=js"
import style0 from "./FGTSConsultRedesign.vue?vue&type=style&index=0&id=38c95625&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c95625",
  null
  
)

export default component.exports